import { FC } from "react";
import { Box, Typography } from "@material-ui/core";

import { Button, Modal } from "components";
import theme from "theme";

const UnsubscribeModal: FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  return (
    <Modal
      open
      onClose={onClose}
      title="You will no longer receive email notifications for this listing."
    >
      <Box
        my={2}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(4),
        }}
      >
        <Typography align="center">
          If you would like to receive email notifications again, favorite the
          listing.
        </Typography>
        <Button fullWidth onClick={onClose} size="large" variant="contained">
          Close
        </Button>
      </Box>
    </Modal>
  );
};

export default UnsubscribeModal;
